// 插槽
export const slotVFrom = [
  {
    name: "demo_jy",
    compontent: () => import("@/views/vform/solt.vue")
  }
];
